import { orthoPagePath } from './orthoMenuPages';

/** Tratamientos de ortodoncia (mismos ítems que Nuestros Tratamientos). */
export const ORTHO_TREATMENT_ITEMS = [
  { pageId: 'metalBraces', imageId: 1 },
  { pageId: 'ceramicBraces', imageId: 16 },
  { pageId: 'invisalign', imageId: 12 },
  { pageId: 'selfLigatingBraces', imageId: 17 },
  { pageId: 'retainers', imageId: 14 },
  { pageId: 'miniImplants', imageId: 15 },
];

export function buildOrthoMegaMenuLinks() {
  return ORTHO_TREATMENT_ITEMS.map(({ pageId }) => ({
    pageId,
    labelKey: `navMega.orthodontics.${pageId}`,
    descKey: `navMega.orthodontics.${pageId}Desc`,
    to: orthoPagePath(pageId),
  }));
}
